import EditIcon from '@mui/icons-material/Edit';
import { GridColDef, GridRowParams } from '@mui/x-data-grid-premium';
import { baseCell, currencyCell } from 'components/cells';
import { numberFilterOperators, filterOperators } from 'components/enhanced';
import { useTranslation } from 'react-i18next';

export function ContractEquipmentColumns(
  handleEdit?: (row: any) => void,
  handleManualDelete?: (id: number) => void,
  disableEdit?: boolean
): GridColDef[] {
  const { t } = useTranslation();
  return [
    {
      field: 'equipment',
      headerName: t(`global.equipment`),
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'description',
      headerName: t(`global.description`),
      width: 250,
      renderCell: baseCell
    },
    {
      field: 'yearly_lease_amount',
      headerName: t(`entities.contract-equipment.yearly_lease_amount`),
      width: 240,
      filterOperators: numberFilterOperators,
      renderCell: currencyCell,
      editable: false
    },
    {
      field: 'yearly_maintenance_amount',
      headerName: t(`entities.contract-equipment.yearly_maintenance_amount`),
      width: 240,
      filterOperators: numberFilterOperators,
      renderCell: currencyCell,
      editable: false
    },
    {
      field: 'purchase_amount',
      headerName: t(`entities.contract-equipment.purchase_amount`),
      width: 240,
      filterOperators: numberFilterOperators,
      renderCell: currencyCell,
      editable: false
    },
    {
      field: 'depreciation_years',
      headerName: t(`entities.contract-equipment.depreciation_years`),
      width: 200,
      filterOperators: numberFilterOperators,
      renderCell: baseCell
    },
    {
      field: 'invoice_frequency',
      headerName: t(`entities.contract.invoice_frequency`),
      filterOperators,
      width: 200,
      valueGetter: (params) =>
        t(`entities.contract.invoice_frequency_options.${String(params.value ?? '').trim()}`),
      renderCell: baseCell
    },
    {
      field: '',
      width: 100,
      type: 'actions',
      headerName: t(`global.actions`),
      getActions: (params: GridRowParams) => {
        return [
          {
            label: t('actions.edit'),
            icon: <EditIcon fontSize="small" />,
            onClick: () => handleEdit(params.row),
            visible: !disableEdit
          }
        ];
      }
    } as GridColDef
  ];
}
